import styled from "styled-components";

export const Container = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	.select {
		--vm-input-padding-y: 16px;
		--vm-input-padding-x: 16px;
		--vm-input-font-size: 16px;
		--vm-input-font-weight: 400;
		--vm-input-line-height: 1.4;
		--vm-input-bg: transparent;
		--vm-input-disabled-bg: #8f8f9a;
		--vm-input-disabled-border-color: #8f8f9a;
		--vm-input-disabled-text-color: #353546;
		--vm-input-color: #ffffff;
		--vm-input-border-color: #353546;
		--vm-input-border-width: 2px;
		--vm-input-box-shadow: inset 0 1px 2px rgba(19, 20, 27, 0.075);
		--vm-input-border-radius: 8px;
		--vm-input-border-radius-sm: 4px;
		--vm-input-border-radius-lg: 16px;
		--vm-input-focus-bg: transparent;
		--vm-input-focus-border-color: #01e59b;
		--vm-input-focus-color: #ffffff;
		--vm-input-focus-width: 4px;
		--vm-input-focus-box-shadow: ;
		--vm-input-placeholder-color: #8f8f9a;
		--vm-input-plaintext-color: #ffffff;
		--vm-input-height-border: 4px;
		--vm-input-height-inner: calc(22px + 32px);
		--vm-input-height-inner-half: calc(11.2px + 16px);
		--vm-input-height-inner-quarter: calc(5.6px + 8px);
		--vm-input-height: calc(22.4px + 36px);
		--vm-input-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		--vm-form-color-width: 48px;
		--vm-form-height: 3.649rem;

		display: block;
		width: 100%;
		padding: var(--vm-input-padding-y) var(--vm-input-padding-x);
		font-size: var(--vm-input-font-size);
		font-weight: var(--vm-input-font-weight);
		line-height: var(--vm-input-line-height);
		color: var(--vm-input-color);
		background-color: var(--vm-input-bg);
		background-clip: padding-box;
		border: var(--vm-input-border-width) solid var(--vm-input-border-color);
		height: var(--vm-form-height);
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border-radius: var(--vm-input-border-radius);
		transition: var(--vm-input-transition);

		text-decoration: none;
		text-align: left;

		border: 2px solid ${({ error }) => (error ? "var(--feedback-error)" : "var(--neutral-strong)")};

		&:focus {
			border-color: ${({ error }) =>
				error ? "var(--feedback-error)" : "var(--brand-primary)"};
		}

		&:active {
			border-color: ${({ error }) =>
				error ? "var(--feedback-error)" : "var(--brand-primary)"};
			color: var(--brand-primary);
		}

		&:focus-visible {
			box-shadow: none;
		}
	}
`;

export const Label = styled.label`
	--vm-form-label-margin-bottom: 4px;
	--vm-form-label-font-size: 12px;
	--vm-form-label-line-height: 1.7;
	--vm-form-label-font-style: ;
	--vm-form-label-font-weight: 600;
	--vm-form-label-color: #ffffff;

	margin-bottom: var(--vm-form-label-margin-bottom);
	font-size: var(--vm-form-label-font-size);
	font-style: var(--vm-form-label-font-style);
	font-weight: var(--vm-form-label-font-weight);
	color: var(--vm-form-label-color);
	line-height: var(--vm-form-label-line-height);

	${({ required }) =>
		required &&
		`
    ::after {
      content: " * ";
    }
  `}
`;
